import { createSelector } from '@reduxjs/toolkit';

import { combineDispatchHalves } from './common/combineDispatchHalves';
import {
  selectDispatchAssignedQueryArgs,
  selectDispatchUnassignedQueryArgs,
} from './common/selectDispatchQueryArgs';
import type { RootState } from 'src/app/store/types';
import { bambiApi } from 'src/common/external/bambi-api/bambiApi';

// endpoints.*.select(args) builds a new memoized selector each call, so cache
// it per args instead of rebuilding it for every consumer on every store
// update.
const selectAssignedCacheEntry = createSelector(
  [selectDispatchAssignedQueryArgs],
  (args) => bambiApi.endpoints.dispatchAssignedRetrieve.select(args)
);
const selectUnassignedCacheEntry = createSelector(
  [selectDispatchUnassignedQueryArgs],
  (args) => bambiApi.endpoints.dispatchUnassignedRetrieve.select(args)
);

/**
 * Single read choke point for the dispatch board, backed by the RTK Query
 * cache entries for the app's own query args — optimistic `updateQueryData`
 * patches and reconcile refetches both land where this reads.
 */
export const selectEffectiveDispatchResponse = createSelector(
  [
    (state: RootState) => selectAssignedCacheEntry(state)(state).data,
    (state: RootState) => selectUnassignedCacheEntry(state)(state).data,
  ],
  combineDispatchHalves
);
